import React, {
  useState,
} from "react";

import style from "./Body.module.css";

import List from "./List/List";
import DetailsOffer from "./List/DetailsOffer/DetailsOffer";
import MyMap from "./MyMap/MyMap";

import {
  Route,
  Switch,
} from "react-router";

const Body: React.FC = () => {
  const [
    mobileView,
    setMobileView,
  ] = useState<"list" | "map">(
    "list"
  );

  return (
    <div className={style.Wrapper}>
      <div
        className={
          style.MobileSwitcher
        }
      >
        <button
          type="button"
          className={
            mobileView === "list"
              ? style.MobileSwitcherActive
              : ""
          }
          onClick={() =>
            setMobileView("list")
          }
        >
          Lista
        </button>

        <button
          type="button"
          className={
            mobileView === "map"
              ? style.MobileSwitcherActive
              : ""
          }
          onClick={() =>
            setMobileView("map")
          }
        >
          Mapa
        </button>
      </div>

      <div className={style.Content}>
        <div
          className={`${style.LeftPane} ${
            mobileView === "map"
              ? style.MobileHidden
              : ""
          }`}
        >
          <Switch>
            <Route
              exact
              path="/offer/:offerID"
              component={DetailsOffer}
            />

            <Route
              path="/"
              component={List}
            />
          </Switch>
        </div>

        <div
          className={`${style.RightPane} ${
            mobileView === "list"
              ? style.MobileHidden
              : ""
          }`}
        >
          <Switch>
            <Route
              exact
              path="/offer/:offerID"
              render={() => (
                <MyMap
                  isDetailsMode
                  isVisible={
                    mobileView === "map"
                  }
                />
              )}
            />

            <Route
              path="/"
              render={() => (
                <MyMap
                  isVisible={
                    mobileView === "map"
                  }
                  onOpenDetails={() =>
                    setMobileView(
                      "list"
                    )
                  }
                />
              )}
            />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Body;